import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import flourishLogo from '../assets/F_YW - montserrat.png';
import './Navbar.css';

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <Link to="/" className="nav-logo">
        <div className="nav-logo">
          <img src={flourishLogo} alt="Flourish" className="nav-logo__img" />
        </div>
      </Link>

      <button
        className="nav-toggle"
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      <div className={`nav-links${open ? ' open' : ''}`} onClick={() => setOpen(false)}>
        <NavLink to="/classes">Classes</NavLink>
        <NavLink to="/teachers">Teachers</NavLink>
        <NavLink to="/passes">Passes</NavLink>
        <NavLink to="/about">About</NavLink>
        <NavLink to="/book">Book</NavLink>
      </div>
    </nav>
  );
}
